<template>
  <ElDialog name="template-party-update-modal"
    :visible="show"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('template.updateTemplatePartyModal.updateParty')"
    append-to-body
  >
    <div>
      <VForm
        :onSubmit="validateForm"
        data-vv-scope="party-edit"
        ref="form"
        :loading="loading">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="12">
              <b>{{ $t('envelope.party.partyTitle') }}</b>
              <VInput
                type="text"
                :class="{ 'a-input--error': errors.has('party-edit.title') }"
                placeholder="e.g. customer"
                v-validate="'required'"
                data-vv-name="title"
                data-vv-as="title"
                data-vv-delay="1000"
                data-ec="edit_template_party_modal"
                data-et="title_input"
                v-model="editParty.title"
                data-vv-scope="party-edit"
                data-hj-suppress
              />
              <VMessage type="error" subtype="basic" v-show="errors.has('party-edit.title')">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('party-edit.title') }}
                </template>
              </VMessage>
            </div>
            <div slot="gridItem" type="6">
              <b>{{ $t('envelope.party.copyOnly') }}&ensp;</b>
              <VCheckbox
                type="checkbox"
                subtype="toggle"
                size="small"
                :checked="receivesCopyOnly"
                v-model="receivesCopyOnly"
                :disabled="deleteProtect"
                data-ec="edit_template_party_modal"
                data-et="receives_copy_only_checkbox" />
            </div>
          </VGrid>
        </div>
        <div slot="row" v-if="errorMessage">
          <VMessage type="error" subtype="basic">
            <template v-slot:icon>
              <LifeRingIcon />
            </template>
            <template v-slot:text>
              {{ errorMessage }}
            </template>
          </VMessage>
        </div>
        <div slot="row" v-if="deleteProtect">
          <VMessage type="warning" subtype="basic">
            <template v-slot:icon>
              <ExclamationTriangleIcon />
            </template>
            <template v-slot:text>
              {{ $t('template.partyHasFieldsWarning') }}
            </template>
          </VMessage>
        </div>
        <div slot="formButtons" type="left">
          <VButton
            type="error"
            :action="deleteParty"
            :disabled="deleteProtect"
            data-ec="edit_template_party_modal"
            data-et="delete_party_button">
            <TrashIcon />
            <span>{{ $t('envelope.party.deleteParty') }}</span>
          </VButton>
        </div>
        <div slot="formButtons" type="right">
          <VButton
            type="cta-1"
            subtype="submit"
            data-ec="edit_template_party_modal"
            data-et="update_button"
            class="pull-right"
            href="#">
            <CheckIcon />
            <span>{{ $t('envelope.party.updateParty') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { CheckIcon, ExclamationTriangleIcon, LifeRingIcon, TrashIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'UpdateTemplatePartyModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    show: Boolean,
    fingerprint: String,
    party: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VButton,
    VCheckbox,
    VInput,
    VMessage,
    VForm,
    VGrid,
    CheckIcon,
    TrashIcon,
    XMarkIcon,
    LifeRingIcon,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      editParty: {
        title: '',
        role: '',
        fields: [],
      },
    };
  },
  watch: {
    party(newValue) {
      this.editParty = JSON.parse(JSON.stringify(newValue));
    },
  },
  created() {
    this.editParty = JSON.parse(JSON.stringify(this.party));
  },
  computed: {
    receivesCopyOnly: {
      get() {
        return this.editParty.role === 'copy';
      },
      // setter
      set(newValue) {
        this.editParty.role = newValue ? 'copy' : 'signer';
      },
    },
    // Checks if party has any fields.
    // If so certain props can't be modified or deleted
    deleteProtect() {
      return !!this.editParty.fields.length;
    },
    templateParties() {
      return this.$store.getters['template/selected'].parties;
    },
  },
  methods: {
    deleteParty() {
      this.loading = true;
      this.$store.dispatch('template/DELETE_PARTY', { party: this.party, fingerprint: this.fingerprint }).then(() => {
        this.$bus.$emit('templatePartyDeleted'); // TODO - bad form. Remove
        this.$emit('close');
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('envelope.party.successfullyDeletedMessage'), icon: 'check', type: 'success' }));
      }).finally(() => {
        this.loading = false;
      });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store.dispatch('template/UPDATE_PARTY', { party: this.editParty, fingerprint: this.fingerprint }).then(() => {
            this.$emit('close');
            this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('envelope.party.successfullyUpdatedMessage'), icon: 'check', type: 'success' }));
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
